var _g, _path, _circle, _rect, _rect2, _rect3, _path2, _path3, _path4, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLighthouseDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "lighthouse-beams",
    stroke: "#16a34a",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 10,
    x2: 6,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 10,
    x2: 3,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 10,
    x2: 6,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 10,
    x2: 42,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 10,
    x2: 45,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 10,
    x2: 42,
    y2: 16
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7 Q24 1 29 7 Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 2.2,
    r: 1.4,
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 7,
    width: 9,
    height: 7,
    rx: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8.5,
    width: 6,
    height: 4,
    rx: 0.8,
    fill: "#16a34a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 14,
    width: 13,
    height: 2.2,
    rx: 0.6,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16 L29 16 L33 40 L15 40 Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 22 L30.1 22 L30.6 25 L17.4 25 Z",
    fill: "var(--lighthouse-band, #f9fafb)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 31 L31.6 31 L32 34 L16 34 Z",
    fill: "var(--lighthouse-band, #f9fafb)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6,
    y: 35,
    width: 2.8,
    height: 5,
    rx: 1.2,
    fill: "var(--lighthouse-band, #f9fafb)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 40,
    width: 24,
    height: 4.5,
    rx: 1.2,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighthouseDefault);
export default __webpack_public_path__ + "static/media/lighthouseDefault.3df8e7340a61f336134133dc4d6fab7d.svg";
export { ForwardRef as ReactComponent };